/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseselectatleastonesubcategory5Inputs */

const en_pleaseselectatleastonesubcategory5 = /** @type {(inputs: Pleaseselectatleastonesubcategory5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select at least one subcategory`)
};

const de_pleaseselectatleastonesubcategory5 = /** @type {(inputs: Pleaseselectatleastonesubcategory5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähl mindestens eine Unterkategorie`)
};

/**
* | output |
* | --- |
* | "Please select at least one subcategory" |
*
* @param {Pleaseselectatleastonesubcategory5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseselectatleastonesubcategory5 = /** @type {((inputs?: Pleaseselectatleastonesubcategory5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseselectatleastonesubcategory5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseselectatleastonesubcategory5(inputs)
	return de_pleaseselectatleastonesubcategory5(inputs)
});
export { pleaseselectatleastonesubcategory5 as "pleaseSelectAtLeastOneSubcategory" }